import stylesTheme from "../stylesTheme";

const DialogPadding = stylesTheme.spacing(3);

export const MuiDialog = {
  MuiDialog: {
    paper: {
      [stylesTheme.breakpoints.only("xs")]: {
        margin: "30px 0 !important",
      },
    },
    paperFullWidth: {
      [stylesTheme.breakpoints.only("xs")]: {
        width: "calc(100% - 10px) !important",
        maxWidth: "calc(100% - 10px) !important",
      },
    },
  },
  MuiDialogTitle: {
    root: {
      padding: DialogPadding,
      paddingBottom: 0,
    },
  },
  MuiDialogContent: {
    root: {
      padding: DialogPadding,
    },
  },
  MuiDialogActions: {
    root: {
      padding: DialogPadding,
      paddingTop: 0,
    },
  },
};
